import React from "react";
import StaticPagesComponent from "../components/pages/StaticPages";

const params = {locale: "de"}

export default function StaticPages() {
    return <StaticPagesComponent />
}